import { t } from "i18next";
// import logo from "../../../assets/images/logo.png";
import images from "../../../resources/images";
import icons, { iconsAlts } from "../../../resources/icons";
import { DropDown } from "../../Common";
import classes from "../VfNavBar.module.css";

const NavBarMobile = ({
  homepageHandler,
  getPrimaryButtonByCountry,
  getInvolvedContent,
  getMobileDropDown,
  getEntitiesContent,
  navigateToAboutUs,
  navigatedToTrademark,
  setSearchModalOpen,
  getInvolvedStyle,
  logClickEvent,
}) => {

  return (
    <>
      <div className={classes.mobileContainer}>
        <div className={classes.leftContainer}>
        <DropDown
            className={getInvolvedStyle()}
            header={t("categories")}
            buttonComponent={<img className={classes.hamburgerMenu} src={icons.hamburgerMenu} />}
            innerComponent={getMobileDropDown}
          />
          <button className={classes.searchContainer} onClick={() => setSearchModalOpen(true)}>
            <img src={icons.searchButtonIcon} alt={iconsAlts.searchButtonIcon} />
          </button>
        </div>
        <div className={classes.rightContainer}>
          {getPrimaryButtonByCountry()}
          <>
            <img
              src={images.logo}
              className={classes.veganLogo}
              onClick={homepageHandler}
              alt={iconsAlts.veganLogo}
            />
          </>
        </div>
      </div>
    </>
  );
};

export default NavBarMobile;
